import QuestionObj from "../Models/QuestionObj";

const Commerce_QSet = [
  new QuestionObj({
    questionSet: {
      English:
        "Does your commerce solution offer a comprehensive portfolio of easy-to-use tools for all business users, regardless of technical knowledge?",
    },
    answerSet: {
      English: [
        "No, our tooling is complex and changes to the site experience frequently require IT intervention",
        "Somewhat, business users can manage some changes to the site experience, but non-technical users may struggle with day-to-day operations",
        "Yes, our commerce solution empowers non-technical business users to own the site experience without additional support",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "How effective is your SEO strategy?",
    },
    answerSet: {
      English: [
        "Not great. Our product pages struggle to rank well in organic search.",
        "Somewhat effective. We’ve organized our products behind commonly searched terms which results in some organic search exposure",
        "Very effective. We have a strong metadata strategy that boosts our organic search visibility and drives site traffic",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English: "How effective is your search experience in guiding customers to their desired purchases?",
    },
    answerSet: {
      English: [
        "We don’t have search functionality",
        "Not especially effective. We have basic search functionality",
        "Somewhat effective. Our search functionality has smart strategies but offers little administrative control",
        "Very effective. We utilize advanced features like dynamic curation, boost and bury, and machine learning to optimize the search",
      ],
    },
    custVals: [25, 50, 75, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "How effective is your product recommendation strategy?",
    },
    answerSet: {
      English: [
        "Not very effective. Recommendations are generic, and we see very little lift to our conversion rates or average order values as a result",
        "Somewhat effective. We see some limited impact of our cross-selling strategy, but we are not able to personalize to every shopper",
        "Very effective. Our product recommendations use real-time strategies and have a measurable impact on our conversion rates and average order values",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Is your customer data connected across CX, finance, and operations applications to better understand and serve your customers’ needs?",
    },
    answerSet: {
      English: [
        "No, our customer data is siloed and disconnected across our business applications",
        "Some customer data is connected across applications, but it isn’t complete, and updates are out of sync",
        "Yes, our customer data is connected and synchronized across core business applications",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "How much variability in pricing and catalogs can you support on your digital channels?",
    },
    answerSet: {
      English: [
        "None. Our digital channels offer static pricing for every account",
        "N/A – We do not sell B2B",
        "We are only able to offer some custom pricing and/or catalogs, but the majority must go through our direct sales channel",
        "We can fully customize our pricing and catalogs to reflect the negotiated terms with every individual account",
      ],
    },
    custVals: [25,50,75, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "How effectively are you able to design and manage promotions strategies?",
    },
    answerSet: {
      English: [
        "We don’t have promotions capabilities",
        "Not very effectively. We only have basic promotions capabilities",
        "Somewhat effectively. Our commerce solution has some out-of-the-box promotions we use",
        "Very effectively. We can use out-of-the-box and custom promotions to meet our needs",
      ],
    },
    custVals: [25,50,75, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Does your commerce solution foster customer loyalty with offers and promotions based on frequent purchase history?",
    },
    answerSet: {
      English: [
        "No, we currently do not offer any incentives for repeat engagement",
        "Somewhat, we utilize a blanket promotion to retain customers",
        "Yes, our solution offers targeted offers and promotions to encourage brand loyalty",
      ],
    },
    custVals: [25,66, 100],
  }),
];

export default Commerce_QSet;
